import produce from 'immer';
import {
  GET_STORE_EARNING_RULES_START,
  GET_STORE_EARNING_RULES_SUCCESS,
  GET_STORE_EARNING_RULES_FAILED,
  GET_STORE_SPENDING_RULES_START,
  GET_STORE_SPENDING_RULES_SUCCESS,
  GET_STORE_SPENDING_RULES_FAILED,
  SAVE_STORE_EARNING_RULES_START,
  SAVE_STORE_EARNING_RULES_SUCCESS,
  SAVE_STORE_EARNING_RULES_FAILED,
  SAVE_STORE_SPENDING_RULES_START,
  SAVE_STORE_SPENDING_RULES_SUCCESS,
  SAVE_STORE_SPENDING_RULES_FAILED,
  GET_STORE_REWARD_BEHAVIOUR_RULES_START,
  GET_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS,
  GET_STORE_REWARD_BEHAVIOUR_RULES_FAILED,
  CHANGE_STORE_BEHAVIOUR_RULE_CONFIGS,
  SAVE_STORE_REWARD_BEHAVIOUR_RULES_START,
  SAVE_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS,
  SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED
} from '../actions/marketing_rules';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';


const initialState = {
  earningRules: [],
  earningRulesIdsToUpdate: [],
  earningRulesConditions: {},
  loadingEarningRules: false,
  spendingRules: [],
  spendingRulesIdsToUpdate: [],
  rewardBehaviourRules: {},
  rewardBehaviourRulesToUpdate: [],
  loadingRewardBehaviourRules: false,
  loadingSaveRewardBehaviourRules: false,
  loadingSpendingRules: false,
  loadingSavingEarningRules: false,
  loadingSavingSpendingRules: false
};


const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_STORE_EARNING_RULES_START: {
      state.loadingEarningRules = true;
      break;
    }

    case GET_STORE_EARNING_RULES_SUCCESS: {
      const {data} = action;

      state.earningRules = data.items;

      state.loadingEarningRules = false;
      state.errorEarningRules = false;
      break;
    }

    case GET_STORE_EARNING_RULES_FAILED: {
      state.loadingEarningRules = false;
      break;
    }

    case GET_STORE_SPENDING_RULES_START: {
      state.loadingSpendingRules = true;
      break;
    }

    case GET_STORE_SPENDING_RULES_SUCCESS: {
      const {data} = action;

      state.spendingRules = data.items;
      state.loadingSpendingRules = false;
      state.errorSpendingRules = false;
      break;
    }

    case GET_STORE_SPENDING_RULES_FAILED: {
      state.loadingSpendingRules = false;
      break;
    }

    case SAVE_STORE_EARNING_RULES_START: {
      state.loadingSavingEarningRules = true;
      break;
    }
    case SAVE_STORE_EARNING_RULES_SUCCESS: {
      const {data} = action;

      state.earningRules = state.earningRules.map((rule) => rule.id === data.id ? data : rule);
      state.earningRulesIdsToUpdate = state.earningRulesIdsToUpdate.filter((rule) => rule !== data.rule_id);
      state.loadingSavingEarningRules = false;
      break;
    }
    case SAVE_STORE_EARNING_RULES_FAILED: {
      state.loadingSavingEarningRules = false;
      break;
    }
    case SAVE_STORE_SPENDING_RULES_START: {
      state.loadingSavingSpendingRules = true;
      break;
    }
    case SAVE_STORE_SPENDING_RULES_SUCCESS: {
      const {data} = action;

      state.spendingRules = state.spendingRules.map((rule) => rule.id === data.id ? data : rule);
      state.spendingRulesIdsToUpdate = state.spendingRulesIdsToUpdate.filter((rule) => rule !== data.rule_id);
      state.loadingSavingSpendingRules = false;
      break;
    }
    case SAVE_STORE_SPENDING_RULES_FAILED: {
      state.loadingSavingSpendingRules = false;
      break;
    }
    case GET_STORE_REWARD_BEHAVIOUR_RULES_START: {
      state.loadingRewardBehaviourRules = true;
      break;
    }

    case GET_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS: {
      const {data} = action;

      //Divide rules by type Account Activation - point_action: 1, Newsletter Signup - point_action: 2, Product Review - point_action: 3
      state.rewardBehaviourRules = data.items.reduce((acc, rule) => {
        if (rule.point_action === 1) {
          return {...acc, 'account activation': rule};
        }

        if (rule.point_action === 2) {
          return {...acc, 'newsletter subscription': rule};
        }

        if (rule.point_action === 3) {
          return {...acc, 'product review': rule};
        }

        return acc;
      }, {});
      state.loadingRewardBehaviourRules = false;
      break;
    }

    case GET_STORE_REWARD_BEHAVIOUR_RULES_FAILED: {
      state.loadingRewardBehaviourRules = false;
      break;
    }
    case CHANGE_STORE_BEHAVIOUR_RULE_CONFIGS: {
      const {keyName, checked, actionType, value, ruleName} = action;
      const isActive = checked ? 1 : 0;
      state.rewardBehaviourRules[ruleName] = {
        ...state.rewardBehaviourRules[ruleName],
        [keyName]: actionType === 'checkbox' ? isActive : value,
      };
      state.rewardBehaviourRulesToUpdate = state.rewardBehaviourRulesToUpdate.filter((rule) => rule.rule_id !== state.rewardBehaviourRules[ruleName].rule_id);
      state.rewardBehaviourRulesToUpdate = [...state.rewardBehaviourRulesToUpdate, state.rewardBehaviourRules[ruleName]];
      break;
    }

    case SAVE_STORE_REWARD_BEHAVIOUR_RULES_START: {
      state.loadingSaveRewardBehaviourRules = true;
      break;
    }
    case SAVE_STORE_REWARD_BEHAVIOUR_RULES_SUCCESS: {
      state.loadingSaveRewardBehaviourRules = false;
      break;
    }
    case SAVE_STORE_REWARD_BEHAVIOUR_RULES_FAILED: {
      state.loadingSaveRewardBehaviourRules = false;
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.earningRules = [];
      state.spendingRules = [];

      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
